import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    text: yup
      .string()
      .required('Text is required')
      .trim()
      .min(1, 'Text must be at least 1 character'),
  })
  .required()

const resAddComment = yupResolver(schema)

export default resAddComment
